import * as Sentry from '@sentry/browser';
import {CaptureConsole, ExtraErrorData} from '@sentry/integrations';
import config from '../../../shared/config/config';

class Logger {
  static initialize() {
    if (config.get('environment') !== 'local') {
      Sentry.init({
        dsn: config.get('sentryDsn'),
        whitelistUrls: [/https?:\/\/((cdn|www)\.)?setapp\.com/],
        environment: config.get('environment'),
        integrations: [
          new ExtraErrorData({depth: 5}),
          new CaptureConsole({levels: ['error']}),
        ],
        ignoreErrors: [
          //  Chrome extensions
          'Non-Error promise rejection captured with value: null',
          'Extension context invalidated.',
          'a[b].target.className.indexOf is not a function. (In \'a[b].target.className.indexOf(Zb)\', \'a[b].target.className.indexOf\' is undefined)',
          //  Tempermonkey - user scripts
          'window.GM_getTab is not a function',
          'undefined is not an object (evaluating \'window.crypto.subtle.generateKey\')',
          //  Ad/tracker blocking
          'UET is not defined',
          'Can\'t find variable: UET',
          // Safari-extensions
          'SyntaxError: The string did not match the expected pattern.',
          // GTM
          'ReferenceError: fbq is not defined',
          // ResizeObserver
          'ResizeObserver loop limit exceeded',
          'ResizeObserver loop completed with undelivered notifications.',
        ],
      });
    }
  }

  static catchError(message, details) {
    if (config.get('environment') === 'local') {
      // eslint-disable-next-line no-console
      console.error(message, details);
    }

    Sentry.withScope((scope) => {
      if (details) {
        scope.setExtras({details});
      }
      Sentry.captureMessage(message, 'error');
    });
  }
}

export default Logger;
